import React from 'react';
import TenantGuard from '@components/common/TenantGuard';
import VisaApplicationReportContainer from '../containers/visa-application-report.container';

export const visaApplicationReportRoutes = [
  {
    path: 'reports',
    element: (
      <TenantGuard showHeader={true} headerTitle="Visa Application Report" showBreadcrumbs={true}>
        <VisaApplicationReportContainer />
      </TenantGuard>
    ),
  },
];

export default visaApplicationReportRoutes;
